import { themes } from '@episource/epi-storybook';
import { createTheme } from '@material-ui/core';
import { merge } from 'lodash';
import overrides from './overrides';

const baseThemeObject = themes.themeObjects.epiportal;
baseThemeObject.palette.primary = {
  contrastText: '#FFFFFF',
  dark: '#0A2A38',
  main: '#0B2A37',
  light: 'rgba(118, 80, 160, 0.17)',
};

const themeObject = {
  overrides,
};

const theme = createTheme(merge(baseThemeObject, themeObject));
export { theme, themeObject };
export default theme;
